import {Col, Row, Spacer, translucify} from '@nfq/react-grid';
import {useTranslation} from 'next-i18next';
import styled from 'styled-components';

import {BaseGrid} from 'UI/components/content/ultra/BaseGrid';
import {DriveGrid} from 'UI/components/content/ultra/DriveGrid';
import {OtherGrid} from 'UI/components/content/ultra/OtherGrid';
import {Eyebrow} from 'UI/components/layout/ultra/Eyebrow';
import {Headline} from 'UI/components/layout/ultra/Headline';
import {HGroup} from 'UI/components/layout/ultra/HGroup';

/**
 * React component for displaying the specification section.
 * This component renders a section containing equipment and specification details.
 *
 * @returns JSX element representing the specification section.
 *
 * @example
 * ```tsx
 * <SpecSection />
 * ```
 */
export const SpecSection = () => {
    const {t} = useTranslation('ultra', {keyPrefix: 'details.specs'});

    return (
        <>
            <Row justify="center">
                <Col lg={10} xs={12}>
                    <HGroup align="center">
                        <Eyebrow>{t('eyebrow')}</Eyebrow>
                        <Headline as="h2">{t('headline')}</Headline>
                    </HGroup>
                </Col>
            </Row>
            <Spacer y={{lg: 20, xs: 12}} />
            <Row justify="center">
                <Col lg={10} xs={12}>
                    <Headline $size="sm">{t('base.headline')}</Headline>
                    <Spacer y={{lg: 16, xs: 8}} />
                    <BaseGrid />

                    <Spacer y={{lg: 4, xs: 0}} />
                    <Divider />
                    <Spacer y={{lg: 20, xs: 10}} />

                    <Headline $size="sm">{t('drive.headline')}</Headline>
                    <Spacer y={{lg: 16, xs: 8}} />
                    <DriveGrid />

                    <Spacer y={{lg: 4, xs: 0}} />
                    <Divider />
                    <Spacer y={{lg: 20, xs: 10}} />

                    <Headline $size="sm">{t('other.headline')}</Headline>
                    <Spacer y={{lg: 16, xs: 8}} />
                    <OtherGrid />
                </Col>
            </Row>
        </>
    );
};

const Divider = styled.div`
    background-color: ${({theme}) => translucify(theme.colors.ultraPageForeground, 30)};
    height: 1px;
`;